import BlankButton from '@xo-union/component-blank-button';
import { H4 } from '@xo-union/tk-ui-typography';
import React from 'react';

import { Sequences } from './messagingHubHelper';
import styles from './sidebarCell.scss';

export interface Props {
  sequence: Sequences[0];
  selectedSequence?: Sequences[0];
  websiteState?: string | null;
  onClick: (sequence?: Sequences[0]) => void;
}

const SidebarCell: React.FC<Props> = ({ sequence, selectedSequence, onClick }) => (
  <BlankButton
    onClick={() => onClick(sequence)}
    className={`${styles.sidebarCell} ${sequence.sequenceType === selectedSequence?.sequenceType ? styles.active : ''}`}
  >
    <H4>{sequence.displayName}</H4>
  </BlankButton>
);

export default SidebarCell;
